import { useSelector } from 'react-redux';
import FJFake3dLeft from './FJFake3dLeft';
import useLocalStore from '../../../hooks/useLocalStore';

const FJFake3dLeftContainer = () => {
    useLocalStore();
    const settingStep = useSelector(state => state.fake3d.settingStep);

    return <FJFake3dLeft settingStep={settingStep} />;
};

export default FJFake3dLeftContainer;
